import { MaintenanceService } from './../service/maintenance.service';
import {
  Component,
  OnInit,
  Input,
  ViewChild,
  TemplateRef,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from 'src/app/core/ui/notification/toast.service';
import { Title, Meta } from '@angular/platform-browser';
import { ResponsiveService } from 'src/app/core/ui/responsive/responsive.service';
import { NgxSpinnerService } from "ngx-spinner";
@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.css'],
})
export class MaintenanceComponent implements OnInit {
  @Input() public address: any;
  @ViewChild('dangerTpl') dangerTpl: TemplateRef<any> | undefined;

  constructor(
    private maintenanceService: MaintenanceService,
    protected activatedRoute: ActivatedRoute,
    private toastService: ToastService,
    private modalService: NgbModal,
    protected titleService: Title,
    private metaService: Meta,
    private responsiveService: ResponsiveService,
    private spinner : NgxSpinnerService
  ) {}
  propertyLink: string | undefined;
  propertyAddress: string | undefined;
  ngOnInit(): void {
    const win = this.responsiveService.getWindow()
    if(win){
      // win.scroll(0,0)
      this.propertyLink = win.location.href;
    }
    const doc = this.responsiveService.getDocument()//TODO: change here
    if(doc && doc.scrollingElement){
      doc.scrollingElement.scrollTop = 0;
    }
    this.titleService.setTitle('Michigan Property Management | Rental Property Management Company in Michigan');
    this.metaService.updateTag(
      { name: 'keywords', content: `Property Management Company, Rental Property Management, Property Management Services` }
    );
    this.metaService.updateTag(
      { name: 'description', content: `Michigan Based North Bloomfield Properties Management Company offers Rental Property Management Services for Property Owners and Tenants in the Michigan area.` }
    );
    this.propertyAddress = this.address;
  }

  maintenanceForm: FormGroup = this.maintenanceService.getmaintenanceForm();
  maintenance() {
    if (this.maintenanceForm.valid) {
      console.log('maintenanceForm', this.maintenanceForm.value);
      this.spinner.show();
      this.maintenanceService
        .sendRequest({
          property: this.maintenanceForm.value.property,
          name: this.maintenanceForm.value.name,
          contact: this.maintenanceForm.value.contact,
          email: this.maintenanceForm.value.email,
          problem: this.maintenanceForm.value.problem,
          time: this.maintenanceForm.value.time,
        })
        .subscribe(
          () => {},
          (error) => {
            // this.showDanger();
            this.spinner.hide();
          },
          () => {
            this.spinner.hide();
            this.showSuccess();
            this.modalService.dismissAll();
            this.maintenanceForm.reset();

          }
        );
    } else {
      // this.showDanger();
      this.maintenanceForm.markAllAsTouched();
      const keys = Object.keys(this.maintenanceForm.controls);
      for (const key of keys) {
        this.maintenanceForm.get(key)?.markAsDirty();
      }
    }
  }

  showSuccess() {
    this.toastService.show(`Thank You \n
    An email has been sent to Our Maintenance Department.
    You will be Contacted by someone shortly`, {
      classname: 'bg-success text-light',
      delay: 10000,
    });
  }

  showDanger() {
    if (!this.dangerTpl) return;
    this.toastService.show(this.dangerTpl, {
      classname: 'bg-danger text-light',
      delay: 15000,
    });
  }
}
